<!-- Action mode: link-styled button that emits (clicked) instead of navigating -->
@if (isAction()) {
  <button
    type="button"
    neo-button
    class="cm-link"
    [class]="color()"
    [class.underline-on-hover]="underlineOnHover()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
    [attr.aut-id]="autId()"
    (click)="onActionClick()"
  >
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </button>
}

<!-- Internal Navigation with routerLink -->
@if (isInternalNavigation() && routerLinkName()) {
  <a
    neo-button
    class="cm-link"
    [class]="color()"
    [class.underline-on-hover]="underlineOnHover()"
    [routerLink]="routerLinkName()"
    [target]="linkTarget()"
    [rel]="linkRel()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
    [attr.aut-id]="autId()"
  >
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </a>
}

<!-- Internal href Navigation (non-external) -->
@if (isInternalNavigation() && !routerLinkName() && href()) {
  <a
    neo-button
    class="cm-link"
    [class]="color()"
    [class.underline-on-hover]="underlineOnHover()"
    [href]="href()"
    [target]="linkTarget()"
    [rel]="linkRel()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
    [attr.aut-id]="autId()"
  >
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </a>
}

<!-- External Navigation with href -->
@if (!isInternalNavigation() && href()) {
  <a
    neo-button
    class="cm-link"
    [class]="color()"
    [class.underline-on-hover]="underlineOnHover()"
    [href]="href()"
    [target]="linkTarget()"
    [rel]="linkRel()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
    [attr.aut-id]="autId()"
  >
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </a>
}

<!-- Shared Link Content Template -->
<ng-template #linkContent>
  <ng-content />
  @if (shouldShowIcon()) {
    @if (icon()) {
      <cm-icon [name]="icon()!" aria-hidden="true" />
    } @else if (isExternalLink() || target() === '_blank') {
      <cm-icon name="open_in_new" aria-hidden="true" />
      <span class="sr-only">(opens in new window)</span>
    }
  }
</ng-template>
